import { env } from '@skin-seoul/env-utils';

import axios, { AxiosInstance } from 'axios';
import qs from 'qs';

/**
 * you can use next cache with fetchOptions
 *
 * example:
 * const { data } = await client.get('/loyalty/balance/123', {
 *   fetchOptions: {
 *     next: {
 *       revalidate: 60,
 *     },
 *     cache: 'force-cache',
 *   },
 */

const convertServerOriginToLoyaltyURL = (url: string) => {
  switch (url) {
    case 'https://dev-api.skin-seoul.com':
      return 'https://dev.skin-seoul.com/api';
    case 'https://staging-api.skin-seoul.com':
      return 'https://staging.skin-seoul.com/api';
    case 'https://api.skin-seoul.com':
      return 'https://skin-seoul.com/api';
    default:
      return 'https://dev.skin-seoul.com/api';
  }
};

export const createSkinSeoulLoyaltyClient = (_baseURL?: string): AxiosInstance => {
  const baseURL = convertServerOriginToLoyaltyURL(_baseURL ?? env('NEXT_PUBLIC_ENV_SERVER_ORIGIN'));

  // Debug logging for environment context
  const isServer = typeof window === 'undefined';
  const hasGlobalEnv = typeof globalThis !== 'undefined' && !!(globalThis as any).__ENV;

  console.debug('[service/loyaltyClient] Creating Loyalty HTTP client:', {
    isServer,
    hasGlobalEnv,
    baseURL,
    envSource: hasGlobalEnv ? 'globalThis.__ENV' : 'process.env or fallback',
  });

  return axios.create({
    baseURL,
    withCredentials: true,
    adapter: 'fetch',
    paramsSerializer: (params) => qs.stringify(params, { indices: false }),
  });
};

export let loyaltyClient: AxiosInstance = createSkinSeoulLoyaltyClient();

export const setLoyaltyClient = (instance: AxiosInstance) => {
  loyaltyClient = instance;
};

